import { lazy, Suspense } from 'react';

// 懒加载组件包装器
const LazyLoad = (path) => {
    const normalizedPath = String(path).replace(/\.index/g, '/index');
    const LazyComponent = lazy(() => import(`../views${normalizedPath}`));

    return (
        <Suspense fallback={
            <div style={{
                height: '100vh', display: 'flex', alignItems: 'center',
                justifyContent: 'center', fontSize: '16px', color: '#666'
            }}>
                加载中...
            </div>
        }>
            <LazyComponent />
        </Suspense>
    );
};

export default LazyLoad;
